{
    "webshop_offer_voucher_correctCode": "Zadán správný kód",
    "webShop_howToFindId_desc": "Své osobní ID najdete na svém hráčském profilu.",
    "webShop_howToFindId_link": "Kde najdu své osobní ID?",
    "webshop_offer_voucher_codeIsIncorrect": "Nesprávný kód",
    "webshop_offer_voucher_enterYourCode": "Zadejte své osobní ID",
    "webShop_unexpectedError_desc": "Došlo k neočekávané chybě, zkuste to prosím později.",
    "webShop_accountBanned_desc": "Účet zablokován!",
    "webshop_confirm": "Ok",
    "webshop_termsConditions_1": "Všeobecné obchodní podmínky",
    "webshop_purchase_privacyPolicy": "Ochrana údajů",
    "webshop_legal_1": "Právní informace",
    "webshop_support_1": "Podpora",
    "mbs_access_welcome_desc": "Vítejte, hráči {0}",
    "btn_login": "Přihlásit se",
    "mbs_access_error_sessionExpired_desc": "Relace vypršela. Zadejte prosím ID účtu ručně."
}
